import './App.css';
import DragAndDrop from './pages/dnd';

function App() {
  return (
    <div>
      <DragAndDrop/>
    </div>
  );
}

export default App;
